import { HighchartsReact } from 'highcharts-react-official';
import Highcharts from 'highcharts';
import React, { useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';



type Props = {
    data: number[];
    categories: string[];
    height?: number;
    column?: boolean;
    series?: Highcharts.Options['series'];
    min?: number;
    max?: number;
}
const HorizontalChart = (props: Props) => {
    const { t } = useTranslation();
    const options: Highcharts.Options = {
        chart: {
            type: props.column ? "column" : "bar",
        },
        title: {
            text: "",
        },
        subtitle: {
            text: "",
        },
        xAxis: {
            title: {
                text: null
            },
            categories: props.categories,
            crosshair: true,
        },
        credits: {
            enabled: false
        },
        tooltip: {
            shared: true,
        },
        plotOptions: {
            column: {
                borderWidth: 0,
                pointPadding: 0.2, // ✅ ป้องกันไม่ให้เกิดจุดแยกออกมา    groupPadding: 0.3,
                legendSymbol: "rectangle",
            },

        },
        yAxis: {
            min: props.min || 0,
            max: props.max,
            // max: 100,
            title: {
                text: "",
            },
            labels: {
                overflow: 'justify'
            },
            gridLineWidth: 0
        },
        series: props.series ? props.series : [
            {
                name: t("หมวดหมู่เรื่องร้องเรียน"),
                type: "column",
                data: props.data,
                color: "#3498db",
            },

            // {
            //     name: "Girls",
            //     type: "column",
            //     data: [24000, 25000, 24500, 26000, 23500, 22500],
            //     color: "#5b2c6f",
            // },
        ],
    };

    return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default HorizontalChart